module.exports = __webpack_public_path__ + "static/mmm_sandwich-fe424a47cf71a9f759527a02a436e7ff.png";